import React, { useState, useEffect } from 'react';
import { Bot } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import SimpleAvatarWidget from './SimpleAvatarWidget';
var VoiceComponent = function (_a) {
    var _b;
    var _c, _d;
    var position = _a.position, header = _a.header, isOpen = _a.isOpen, onClose = _a.onClose, onToggle = _a.onToggle, email = _a.email, language = _a.language, domain = _a.domain, _e = _a.mode, mode = _e === void 0 ? 'avatar' : _e;
    var _f = useState(position.side || 'right'), side = _f[0], setSide = _f[1];
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var buttonSize = isMobile ? '3.5rem' : '4rem'; // 56px for mobile, 64px for desktop
    var iconSize = isMobile ? '1.75rem' : '2rem'; // 28px for mobile, 32px for desktop
    useEffect(function () {
        setSide(position.side || 'right');
    }, [position.side]);
    return (React.createElement(React.Fragment, null,
        React.createElement(AnimatePresence, null, isOpen && (React.createElement(SimpleAvatarWidget, { isOpen: isOpen, onClose: onClose, side: side, verticalPosition: position.verticalAlign, header: header, domain: 'halfmillion', mode: mode }))),
        React.createElement(motion.button, { className: "fixed ".concat(isOpen ? 'bg-bot-primary' : 'bg-bot-gradient', " rounded-full flex items-center justify-center shadow-lg hover:shadow-xl z-40"), whileHover: { scale: isOpen ? 1 : 1.1 }, whileTap: { scale: isOpen ? 1 : 0.95 }, onClick: onToggle, style: (_b = {
                    position: 'fixed'
                },
                _b[position.side] = ((_c = position.offset) === null || _c === void 0 ? void 0 : _c[position.side]) || '20px',
                _b.bottom = ((_d = position.offset) === null || _d === void 0 ? void 0 : _d.bottom) || '20px',
                _b.width = buttonSize,
                _b.height = buttonSize,
                _b) },
            React.createElement(Bot, { style: { width: iconSize, height: iconSize }, className: "text-white" }))));
};
export default VoiceComponent;
